/**
 * An abstract class for schema content.
 */
import { XmlSchemaAnnotated } from './XmlSchemaAnnotated';

export abstract class XmlSchemaContent extends XmlSchemaAnnotated {}
